import React from 'react';
import {NewsList} from '../parts/index';
import { axiosApi } from '../../assets/axiosAPI';
import { API_PATH, LOGOUT } from '../../assets/const';
import {getSessionInfo} from '../../assets/common';

const GET_NEWS = API_PATH + "/resources/news";

export default class Home extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            newsList:[]
        }
    }

    componentDidMount = () => {
        //getSessionInfo();
        document.body.id = "";
        this.fetchNews();
    }

    //お知らせ一覧の取得
    fetchNews = () =>{
        axiosApi
            .get(GET_NEWS)
            .then((response) => {
                const _responseData = response.data;
                const _newsList = _responseData.newsList;
                const _sortNewsList = _newsList.sort((a, b) =>{
                    let compare = 0;
                    if(a.newsDate > b.newsDate){
                        compare = -1;
                    }
                    if(b.newsDate > a.newsDate){
                        compare = 1;
                    }
                    return compare;
                })
                this.setState({
                    newsList : _sortNewsList
                })
            })
            .catch((error) => {
                if(error.response){
                    const _statusCode = error.response.status;
                    if (_statusCode === 401) {
                        //セッションまたは権限なし
                        alert("セッションまたは権限がありません。ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }else{
                        //入らない処理
                        alert("ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }
                }else{
                    //レスポンス取得後のエラー or 通信失敗時のエラー
                    alert("予期せぬエラーが発生しました。ログイン画面へ戻ります。");
                    window.location.href = LOGOUT;
                }   
            });
    }

    render(){
        return(
            <div>
                <h1 className="PageTitle">Home</h1>
                <div className="main">
                <NewsList 
                    newsList={this.state.newsList}
                    displayType="Home" />
                </div>
            </div>
        )
    }
}